import { concat } from 'lodash';

import { SCOPES } from 'constants/roles';

import SettingsInstance from './navigation-settings-instance';
import SettingsMyPreferences from './navigation-settings-my-preferences';

export default {
  label: 'label.settings',
  name: 'settings',
  type: 'section',
  url: '/professional/settings',
  navigationIcon: 'far fa-cog',
  scope: SCOPES.INSTANCE_STAFF,
  pages: concat(
    SettingsInstance,
    SettingsMyPreferences,
  ),
};



// WEBPACK FOOTER //
// ./src/data/navigations/settings/index.js